import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useI18n } from "@/i18n";
import { useAuth } from "./AuthContext";

export function UpdatePasswordPage() {
  const { t } = useI18n();
  const { clearPasswordRecovery, signOut } = useAuth();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t("error"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center p-6">
      <div className="card">
        <h1 className="mb-1 text-2xl font-bold text-accent">{t("appName")}</h1>
        <p className="mb-6 text-sm text-muted">{t("resetPassword")}</p>

        {done ? (
          <div className="space-y-4">
            <p className="text-sm text-green-600">{t("passwordUpdated")}</p>
            <button
              className="btn-primary w-full"
              onClick={() => {
                clearPasswordRecovery();
              }}
            >
              {t("login")}
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">{t("newPassword")}</label>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
                autoFocus
              />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}

            <button className="btn-primary w-full" disabled={busy}>
              {busy ? t("loading") : t("updatePassword")}
            </button>

            <button
              type="button"
              className="w-full text-sm text-muted"
              onClick={async () => {
                clearPasswordRecovery();
                await signOut();
              }}
            >
              {t("backToLogin")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
